// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-thumbnail-canvas[data-v-15742d44],.video-thumbnail-image[data-v-15742d44]{width:100%;height:auto}.video-thumbnail-overlay[data-v-15742d44]{position:relative;margin-top:-100%}.video-thumbnail-overlay img[data-v-15742d44]{width:100%}", ""]);
// Exports
module.exports = exports;
